











































import './KisweOverlay.scss'
import { defineComponent } from '@vue/composition-api'
import KisweStudioLogo from '../KisweStudioLogo'
import { KisweIcon, KisweButton } from '@/modules/kisweui/components'
import { useTeamBranding } from '@/modules/teams/compositions'
import LanguageSelector from '@/modules/translation/components/LanguageSelector'

export default defineComponent({
  name: 'KisweOverlay',
  components: {
    KisweButton,
    KisweIcon,
    KisweStudioLogo,
    LanguageSelector
  },
  props: {
    isLockPortraitOnMobile: {
      type: Boolean,
      required: false,
      default: false
    },
    isModal: {
      type: Boolean,
      required: false,
      default: false
    },
    outsideClose: {
      type: Boolean,
      required: false,
      default: false
    },
    showClose: {
      type: Boolean,
      required: false,
      default: true
    },
    showBgImage: {
      type: Boolean,
      required: false,
      default: true
    },
    showLogo: {
      type: Boolean,
      required: false,
      default: true
    },
    showLanguageSelector: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: {
    close () { return true }
  },
  setup () {
    const { branding, isBranded, cssVariables } = useTeamBranding('.kiswe-overlay-popper')

    return {
      branding, cssVariables, isBranded
    }
  },
  methods: {
    closeFromOutside () {
      if (this.outsideClose) this.$emit('close')
    }
  }
})
